import * as React from "react"
import 'bootstrap/dist/css/bootstrap.css'
import "bootstrap-icons/font/bootstrap-icons.css";
import "./styles/main.css"
import "../sb/main.css"
import "../sb/plugins.css"
import Testimonials from "../components/testimonials/testimonials";
import Layout from "../components/layout/layout";
import About from "../components/about/about";
import Ready from "../components/products/ready/ready";

const HomePage = () => {
    return (
        <Layout isHomePage={true}>
            <Ready/>
            <Testimonials/>
            <About/>
        </Layout>
    )
}

export default HomePage